<template>
  <div class="energy-trends">
    <div class="energy-trends-title">制冷能耗趋势</div>
    <div class="energy-trends-condition">
      <div class="item">
        <span class="title">制冷机组</span>
        <el-select v-model="buildingId" :clearable="dateClear" placeholder="请选择" style="width: 70%;"
          @change="queryTodayConsumption">
          <el-option v-for="item in buildingOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span class="title">日期</span>
        <el-date-picker v-model="selectDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
          :clearable="dateClear" style="width: 60%;" @change="queryTodayConsumption" />
      </div>
    </div>
    <div class="energy-trends-legend">
      <div class="legend-label-second"></div>
      <div class="legend-text">谷</div>
      <div class="legend-label-third"></div>
      <div class="legend-text">平</div>
      <div class="legend-label-first"></div>
      <div class="legend-text">峰</div>
    </div>
    <div class="energy-trends-charts">
      <div id="buildingPowerChart" style="width: 100%; height: 12rem"></div>
    </div>
  </div>
</template>

<script>
import { api } from '../api/api'
import dayjs from "dayjs"
import eCharts from "echarts"
export default {
  data() {
    return {
      buildingId: 8,
      buildingOpts: [{ 'label': '1号冷库制冷机组', 'value': 8 }, { 'label': '5号冷库制冷机组', 'value': 9 }],
      selectDate: dayjs(new Date().setDate(new Date().getDate() - 1)).format('YYYY-MM-DD'),
      dateClear: false,
      buildingPowerChart: null,
      todayConsumption: {}
    }
  },
  mounted() {
    this.queryTodayConsumption()
    window.onresize = () => {
      this.buildingPowerChart.resize()
    };
  },
  methods: {
    // async queryBuildList() {
    //   const { success, returnObj } = await this.$fetch(api.getBuildList)
    //   if (success) {
    //     this.buildingOpts = returnObj.map(v => {
    //       return {
    //         label: v.name,
    //         value: v.id
    //       }
    //     })
    //   }
    // },
    async queryTodayConsumption() {
      const {
        success,
        returnObj
      } = await this.$fetch(api.todayConsumption + '?buildId=' + this.buildingId + '&date=' + this.selectDate)
      if (success) {
        this.todayConsumption = returnObj
        this.initBuildingPowerChart();
      }
    },
    initBuildingPowerChart() {
      let chartDom = document.getElementById("buildingPowerChart");
      this.buildingPowerChart = eCharts.init(chartDom);
      const lineColor = ['rgba(18, 206, 108, 0.7)', 'rgba(130, 107, 244, 0.7)', 'rgba(242, 75, 75, 0.7)']
      const arrLength = this.todayConsumption.chartData ? this.todayConsumption.chartData.length : 0
      const pieces = this.todayConsumption.chartData.map((v, index) => {
        return {
          lte: index == arrLength - 1 ? null : index + 1,
          gt: index == 0 ? null : index,
          color: lineColor[v.type],
        }
      })
      this.buildingPowerChartOpt = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          left: '1%',
          right: '5%',
          bottom: '0',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          name: '时',
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          }, // X轴底部文字颜色
          axisLabel: {
            interval: 0,//横轴信息全部显示
            rotate: -50,// -20度角倾斜显示
          }, // X轴底部文字倾斜，用于文字过多，有些字不展示的处理
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          }, // X轴网格线的颜色和solid
          data: this.todayConsumption.chartData.map(v => v.dataTime),
        },
        yAxis: {
          type: 'value',
          name: "单位：kwh",
          axisLabel: {
            formatter: '{value}'
          },
          axisPointer: {
            snap: true
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          }, // Y轴底部文字颜色
          // splitLine: {
          //   lineStyle: {
          //     color: "rgba(104,105,123)",
          //     type: "dashed"
          //   }
          // },
        },
        visualMap: {
          show: false,
          dimension: 0,
          pieces: pieces
        },
        series: [
          {
            areaStyle: {},
            name: "用电量",
            type: 'line',
            smooth: true,
            data: this.todayConsumption.chartData.map(v => v.value),
          }
        ]
      };
      this.buildingPowerChart.setOption(this.buildingPowerChartOpt);
    },
  }
}
</script>

<style lang="scss" scoped>
.energy-trends {
  width: 100%;
  height: 100%;
}

.energy-trends-title {
  margin: 15px 0 0 10px;
  font-size: 16px;
  font-weight: bold;
}

.energy-trends-condition {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  margin-top: 20px;

  .item {
    margin-right: 10px;

    .title {
      margin-right: 10px;
    }
  }
}

.energy-trends-legend {
  display: flex;
  margin-left: 10px;
  margin-top: -23px;

  .legend-label-first {
    width: 30px;
    height: 15px;
    background-color: rgba(242, 75, 75, 0.7);
    margin-right: 10px;
    margin-left: 15px;
  }

  .legend-label-second {
    width: 30px;
    height: 15px;
    background-color: rgba(18, 206, 108, 0.7);
    margin-right: 10px;
  }

  .legend-label-third {
    width: 30px;
    height: 15px;
    background-color: rgba(130, 107, 244, 0.7);
    margin-right: 10px;
    margin-left: 15px;
  }
}
</style>